import { css } from 'styled-components';

export const breakpoints = {
  site: 1280,
  tablet: 960,
  tabletSmall: 720,
  mobile: 360,
};

export const defaultLayout = 'desktop';

export const matchMedia = (width, media) => {
  if (media) {
    return width <= breakpoints[media];
  } else {
    const match = Object.keys(breakpoints).map(key => ({ label: key, width: breakpoints[key] }))
    .sort((a, b) => (a.width === b.width) ? 0 : (a.width > b.width) ? 1 : -1)
    .find(bp => width <= bp.width);
    return match ? match.label : defaultLayout;
  }
};

// Iterate through the breakpoints and create a media template
export const media = Object.keys(breakpoints).reduce((acc, label) => {
	acc[label] = (...args) => css`
		@media (max-width: ${breakpoints[label] / 16}em) {
			${css(...args)}
		}
	`;
	return acc;
}, {});



// WEBPACK FOOTER //
// ./src/core/layout/media.js